import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAemConfig } from '@as-react/common-components';
import { isOneSizeProduct } from '@as-react/common-utils';
import { InfoIcon } from '@yonderland/andes-icons';
import { Icon, StackInline, TextAlpha } from '@yonderland/andes-react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { makeGetProductSizes, makeGetSizeCombinationNotExist, makeGetSkuAvailability, } from '../../../redux/product/selectors/ProductSelector';
export const LimitedStockNotification = () => {
    const { oneSizeProductCode, market } = useAemConfig();
    const { t } = useTranslation(I18N_NAMESPACES.product);
    const sizes = useSelector(makeGetProductSizes());
    const skuAvailability = useSelector(makeGetSkuAvailability());
    const sizeCombinationNotExist = useSelector(makeGetSizeCombinationNotExist());
    const oneSizeProduct = isOneSizeProduct(sizes, oneSizeProductCode);
    const getMessage = () => {
        if (sizeCombinationNotExist) {
            return t(`pdp.size.combination.${market === 'be' ? 'be.' : ''}not.exist.error`);
        }
        if (skuAvailability.isSoldOut && !oneSizeProduct) {
            return t(`product.selected.size.${market === 'be' ? 'be.' : ''}unavailable`);
        }
        if (skuAvailability.exactAvailability && skuAvailability.exactAvailability > 0) {
            return t('product.last.pieces.exact', {
                amount: skuAvailability.exactAvailability,
            });
        }
        if (skuAvailability.lastPieces) {
            return t('product.last.pieces');
        }
        return '';
    };
    const message = getMessage();
    return message ? (_jsxs(StackInline, { itemsAlign: "center", gap: "1", children: [_jsx(Icon, { source: InfoIcon, color: "error", size: "xs" }), _jsx(TextAlpha, { color: "error", children: message })] })) : null;
};
